/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Use_4_ValueInputs */

const en_svc_agents_use_4_value = /** @type {(inputs: Svc_Agents_Use_4_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacts, deals and notes stay current without anyone retyping them.`)
};

const lv_svc_agents_use_4_value = /** @type {(inputs: Svc_Agents_Use_4_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakti, darījumi un piezīmes ir aktuāli, un nevienam tie nav jāpārraksta.`)
};

/**
* | output |
* | --- |
* | "Contacts, deals and notes stay current without anyone retyping them." |
*
* @param {Svc_Agents_Use_4_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_use_4_value = /** @type {((inputs?: Svc_Agents_Use_4_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Use_4_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_use_4_value(inputs)
	return en_svc_agents_use_4_value(inputs)
});